import { render, staticRenderFns } from "./IndisponivelBadge.vue?vue&type=template&id=b8679aea"
import script from "./IndisponivelBadge.vue?vue&type=script&lang=js"
export * from "./IndisponivelBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports